// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/home.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/home'

import { Icon, type IconComponentProps } from '../icon'

export const HomeIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
